import { useState } from "react";
import axios from "axios";
import "./Users.css";

const API_BASE = process.env.REACT_APP_API_BASE || "http://127.0.0.1:8000";

export default function Users() {
  const [form, setForm] = useState({
    username: "",
    password: "",
    confirmPassword: "",
  });

  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState("");
  const [toastType, setToastType] = useState("success"); // "success" or "error"

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (form.password !== form.confirmPassword) {
      setToast("Passwords do not match");
      setToastType("error");
      return;
    }

    const token = localStorage.getItem("access");

    if (!token) {
      setToast("Authentication required. Please sign in.");
      setToastType("error");
      return;
    }

    try {
      setLoading(true);

      await axios.post(
        `${API_BASE}/admin/create-sales/`,
        {
          username: form.username,
          password: form.password,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // ✅ Success toast
      setToast("Sales user created successfully!");
      setToastType("success");
      setForm({ username: "", password: "", confirmPassword: "" });

      // Auto-hide toast
      setTimeout(() => setToast(""), 3000);
    } catch (err) {
      setToast(err.response?.data?.detail || "Admin or Superadmin required");
      setToastType("error");
      setTimeout(() => setToast(""), 4000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="create-user">
      <h2>Create Sales User</h2>

      <form onSubmit={handleSubmit}>
        <input
          name="username"
          placeholder="Username"
          value={form.username}
          onChange={handleChange}
          required
        />
        <input
          type="password"
          name="password"
          placeholder="Password"
          value={form.password}
          onChange={handleChange}
          required
        />
        <input
          type="password"
          name="confirmPassword"
          placeholder="Confirm Password"
          value={form.confirmPassword}
          onChange={handleChange}
          required
        />

        <button disabled={loading}>
          {loading ? "Creating..." : "Create User"}
        </button>
      </form>

      {/* ✅ Toast message */}
      {toast && (
        <div className={`toast ${toastType}`}>
          {toast}
          <button className="toast-close-btn" onClick={() => setToast("")}>
            ×
          </button>
        </div>
      )}
    </div>
  );
}
